// no conflict
var $ = jQuery.noConflict();

$(document).ready(function () {
	//Trigger AOS
	AOS.init({
		duration: 4000,
		easing: "ease-in-out",
		once: true,
		mirror: false,
		disable: window.innerWidth < 768,
	});

	// Sticky nav scroll logic
	$(window).on("scroll", function () {
		var sc = $(window).scrollTop();
		if (sc > 100) {
			$("#header").addClass("sticky-nav");
		} else {
			$("#header").removeClass("sticky-nav");
		}
	});

	// Run on page load
	var sc = $(window).scrollTop();
	if (sc > 100) {
		$("#header").addClass("sticky-nav");
	}

	// ✅ OPEN MODAL
	$("[data-modal-target]").on("click", function (e) {
		e.preventDefault();

		var modalId = $(this).data("modal-target");
		var $modal = $("#" + modalId);

		if ($modal.length) {
			$modal.removeClass("hidden");
			$("body").addClass("modal-open");
		}
	});

	// ✅ CLOSE MODAL and stop media
	function closeModal($modal) {
		if ($modal.length) {
			$modal.addClass("hidden");

			// Remove body class only if no modals remain open
			if ($(".modal:not(.hidden)").length === 0) {
				$("body").removeClass("modal-open");
			}

			// Pause <video> elements
			$modal.find("video").each(function () {
				this.pause();
				this.currentTime = 0;
			});

			// Stop <iframe> playback (e.g. YouTube)
			$modal.find("iframe").each(function () {
				var $iframe = $(this);
				var src = $iframe.attr("src");
				$iframe.attr("src", src);
			});
		}
	}

	// ✅ Close via button
	$(".closeModal").on("click", function (e) {
		e.preventDefault();
		e.stopPropagation();

		var $modal = $(this).closest(".modal");
		closeModal($modal);
	});

	// ✅ Close when clicking outside modal content
	$(".modal.fixed").on("click", function (e) {
		var $modalContent = $(this).children("div").first();

		if (
			!$modalContent.is(e.target) &&
			$modalContent.has(e.target).length === 0
		) {
			closeModal($(this));
		}
	});
});
